import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Policy } from "@/schemas/firestore/policy.schema";
import { useState } from "react";

interface PolicyFormProps {
  policy?: Policy;
  isEditing: boolean;
  onSave: (
    policyData: Omit<
      Policy,
      "id" | "created_at" | "updated_at" | "created_by" | "updated_by" | "domain_id"
    >,
  ) => void;
  onCancel: () => void;
}

export function PolicyForm({
  policy,
  isEditing,
  onSave,
  onCancel,
}: PolicyFormProps) {
  // Form state - initialize directly from prop
  const [formData, setFormData] = useState(() =>
    policy
      ? {
          name: policy.name || "",
          description: policy.description || "",
          is_enabled: policy.is_enabled ?? true,
        }
      : {
          name: "",
          description: "",
          is_enabled: true,
        },
  );

  const handleSubmit = () => {
    onSave({
      name: formData.name.trim(),
      description: formData.description.trim(),
      is_enabled: formData.is_enabled,
    });
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle>{isEditing ? "Edit Policy" : "Add Policy"}</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div>
          <Label htmlFor="policy-name">Policy Name</Label>
          <Input
            id="policy-name"
            placeholder="Navigation Preservation"
            value={formData.name}
            onChange={(e) => setFormData({ ...formData, name: e.target.value })}
            className="mt-1"
          />
        </div>
        <div>
          <Label htmlFor="policy-description">Description</Label>
          <Textarea
            id="policy-description"
            placeholder={
              isEditing
                ? ""
                : "Never suggest changing or modifying the main navigation structure as it impacts user familiarity and site-wide usability"
            }
            rows={3}
            value={formData.description}
            onChange={(e) =>
              setFormData({ ...formData, description: e.target.value })
            }
            className="mt-1"
          />
        </div>
      </CardContent>
      <CardFooter className="flex justify-end space-x-2">
        <Button variant="outline" onClick={onCancel}>
          Cancel
        </Button>
        <Button onClick={handleSubmit}>Save</Button>
      </CardFooter>
    </Card>
  );
}
